import React, {useContext} from "react";
import styled from "styled-components";
// @ts-ignore
import classNames from 'classnames';
import {useTranslation} from "react-i18next";
// @ts-ignore
import {Link} from "react-router-dom";
import RankingsAndLevelsUtils from "../../../services/RankingsAndLevelsUtils";
import '../RankingsAndLevels.css';

import Constants from "../../../data/Constants";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import Colors from "../../../assets/colors/Colors";

const TabTitle = styled.div`
    font-family: ${(props: {tabId: number, selectedTabId: number}) => (props.tabId ===  props.selectedTabId ? 'DMSans-Black' : 'DMSans-Light')};;
    cursor: pointer;
`;

const SeparatorDiv = styled.div`
    border-left: 4px solid;
    height: 50px;
    margin: 0px 30px 0px 30px;
`;

const SeparatorHorizontalDiv = styled.div`
    flex: 0;
    border-top: 4px solid;
    margin-top: 5px;
    width: 100%;
    margin-bottom: 30px;
`;

const But = styled(Link)`
    div {
        color: ${(props: {isLife: boolean}) => props.isLife ? Colors.fontGray : Colors.fontWhite};
        background: ${(props: {isLife: boolean}) => props.isLife ? Colors.fontWhite : Colors.fontGray};
    }

    div:hover {
        text-decoration-color: ${(props: {isLife: boolean}) => props.isLife ? Colors.fontWhite : Colors.fontGray};
    }

    background-color:  ${(props: {isLife: boolean}) => props.isLife ? Colors.fontWhite : Colors.fontGray};;
    border-color:  ${(props: {isLife: boolean}) => props.isLife ? Colors.fontWhite : Colors.fontGray};;
    color: black;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

`;

interface ContentRankingProps {
    tabSelected: number,
    handleTabSelection: (id: number) => void
}
const ContentRankingComponent: React.FC<ContentRankingProps> = ({tabSelected, handleTabSelection}) => {
    const { t } = useTranslation();
    const lifeValues = RankingsAndLevelsUtils.lifeValues;
    //@ts-ignore
    const {isLife} = useContext(RankingsAndLevelsContext);

    return (
        <div className='content-container'>
            <div className={classNames('title-container', 'basic-container-row')}>
                <TabTitle
                    tabId={lifeValues.life}
                    selectedTabId={tabSelected}
                    onClick={() => handleTabSelection(lifeValues.life)}
                >
                    { t('lifeSelector.life') }
                </TabTitle>
                <SeparatorDiv />
                <TabTitle
                    tabId={lifeValues.noLife}
                    selectedTabId={tabSelected}
                    onClick={() => handleTabSelection(lifeValues.noLife)}
                >
                    { t('lifeSelector.noLife') }
                </TabTitle>
            </div>

            <div className={classNames('subtitle-container', 'basic-container-row', 'rankings-font')}>
                {t('rankingsAndLevels.title')}
            </div>

            <div className={classNames('basic-container-row', 'justify-text')}>
                { t('rankingsAndLevels.description') }
            </div>
            <div className='button-container' style={{ marginTop: '20px' }}>
                <SeparatorHorizontalDiv />
                <But to={Constants.routes.rankingsMap} isLife={isLife}>
                    <div>{ t('rankingsAndLevels.visitCountry') }</div>
                </But>
            </div>
            <div className={classNames('subdescription-container', 'basic-container-row')}></div>
        </div>
    )
};

export default ContentRankingComponent;
